// extracted by mini-css-extract-plugin
module.exports = {"hp-bar":"HpBar_hp-bar__3XeYa","hp-bar__fill":"HpBar_hp-bar__fill__2hnUr","hp-bar__text":"HpBar_hp-bar__text__22dun"};